/* eslint-disable */
import React, { PureComponent, Fragment } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import styles from './index.css';

import RankingNav from './rankingNav';

import ImgBox from './ImgBox';

import { Alert } from '../../../components/modal';

/**
 * 区域盛典
 */
class RankingList extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        curArea:
            (this.props.content.rankingNav &&
                this.props.content.rankingNav[0] &&
                this.props.content.rankingNav[0].title) ||
            '北京',
    };

    handleAreaChange = curArea => {
        const {
            content: { onlineArea },
        } = this.props;

        if (onlineArea.filter(i => i.title === curArea)[0].showRanklist) {
            this.setState({ searchValue: '' });
            this.setState({ curArea }, () => {});
        } else {
            Alert.show({
                content: (
                    <Fragment>
                        <div className={styles.alerttitleBox}>
                            <div className={styles.alerttitle}>
                                {(onlineArea.filter(i => i.title === curArea)[0] &&
                                    onlineArea.filter(i => i.title === curArea)[0].ranklistmsg) ||
                                    '尚未开启'}
                            </div>
                        </div>
                        <div className={styles.alertcontent}>敬请期待</div>
                    </Fragment>
                ),
            });
        }
    };

    render() {
        const { curArea } = this.state;
        const { rankingNav, rankingList } = this.props.content;

        const loadImgUrl =
            'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="349" height="196"><text x="120" y="108" fill="%23dcdcdc" style="font-size: 28px;">鳳凰新聞</text></svg>';

        return (
            <section className={styles.rankingList}>
                <RankingNav content={rankingNav} cur={curArea} onChange={this.handleAreaChange} />
                <ImgBox rankingNav={rankingNav} rankingList={rankingList} curArea={curArea} />
            </section>
        );
    }
}

export default errorBoundary(RankingList);
